import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  makeStyles,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  Card
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Supplier } from 'src/types/supplier';
import clsx from 'clsx';
import useResolution from 'src/hooks/useResolution';

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    borderRadius: 4,
    overflow: 'hidden',
    border: '1px solid #7D879C',
    marginTop: theme.spacing(2)
  },
  dialogContent: {
    minWidth: 340,
    position: 'relative',
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      overflowX: 'hidden'
    }
  },
  contactItem: {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  table: {
    borderCollapse: 'collapse'
  },
  cell: {
    border: '1px solid #7D879C',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '33.33%'
  },
  email: {
    color: '#2F80ED'
  },
  closeIcon: {
    position: 'absolute',
    right: 0
  }
}));

interface ViewContactsDialogProps {
  open: boolean;
  onClose: () => void;
  supplier?: Supplier;
}

const ViewContactsDialog = ({
  open,
  onClose,
  supplier
}: ViewContactsDialogProps) => {
  const classes = useStyles();
  const { isMobile, sm } = useResolution();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent className={classes.dialogContent}>
        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={onClose}
            style={{ padding: 0, marginBottom: '1rem' }}
          >
            <CloseIcon
              style={{ color: '#CF151A' }}
              className={classes.closeIcon}
            />
          </Button>
        </Box>
        <Typography
          variant="h4"
          component="span"
          style={{
            fontWeight: 500,
            color: '#0C304A',
            fontSize: isMobile ? 16 : ''
          }}
        >
          All Contacts ({supplier?.name || 'Supplier'})
        </Typography>
        {supplier?.contacts?.length ? (
          isMobile && sm ? (
            <>
              {(supplier?.contacts || []).map((contact, index) => (
                <Card
                  key={index}
                  style={{
                    wordWrap: 'break-word',
                    overflowX: 'hidden',
                    margin: '16px 0',
                    padding: '16px'
                  }}
                >
                  <Typography>
                    <strong>Name:</strong> {contact.name || '-'}
                  </Typography>
                  <Typography>
                    <strong>Contact No:</strong> {contact.contact_no || '-'}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong>{' '}
                    <span className={classes.email}>
                      {contact.email || '-'}
                    </span>
                  </Typography>
                </Card>
              ))}
            </>
          ) : (
            <div className={classes.tableWrapper}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.cell}>Name</TableCell>
                    <TableCell className={classes.cell}>Contact No</TableCell>
                    <TableCell className={classes.cell}>Email</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(supplier?.contacts || []).map((contact, index) => (
                    <TableRow key={index} className={classes.contactItem}>
                      <TableCell className={classes.cell}>
                        {contact.name || '-'}
                      </TableCell>
                      <TableCell className={classes.cell}>
                        {contact.contact_no || '-'}
                      </TableCell>
                      <TableCell className={clsx(classes.cell, classes.email)}>
                        {contact.email || '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )
        ) : (
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ marginTop: '1em', marginBottom: '1em' }}
          >
            No contacts available
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewContactsDialog;
